import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface InvalidPlacementDialogProps {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
}

export function InvalidPlacementDialog({ open, onCancel, onProceed }: InvalidPlacementDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="warning" />
        Invalid Placement Warning
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          The selected placement may cause the part to collide or interlock with another part. Are you sure you want to proceed?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onProceed} color="warning" variant="contained" autoFocus>
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
